import React, { Component, Fragment } from 'react';
import { inject, observer } from 'mobx-react';
import b from 'b_';
import EmailRegStore from '../../../stores/EmailRegStore';
import RegOptionsStore from '../../../stores/RegOptionsStore';
import SnackStore from '../../../stores/SnackStore';
import FuseConfirmationModal from '../../ConfirmationModal/FuseConfirmationModal';
import FuseButton from '../../FuseControls/FuseButton';
import { Card, FTLabel } from '../../Fuse';
import FuseConsoleModal from '../../ConsoleModal/FuseConsoleModal';
import FuseInfoTooltip from '../../FuseControls/FuseTooltip/FuseInfoTooltip';
import FuseSwitch from '../../FuseControls/FuseSwitch';
import FuseRadioButton from '../../FuseControls/FuseRadioButton';
import ConsoleStore from '../../../stores/ConsoleStore';
import UDSpinner from '../../UD/Fragments/UDSpinner';
import FuseAlert from '../../FuseControls/FuseAlert';
import FuseConsoleCardFooter from '../../ConsoleFragments/FuseConsoleCardFooter';
import './BrowserRegistrationModal.css';

const block = b.lock('BrowserRegistrationModal');

class BrowserRegistrationModal extends Component {
    static propTypes = {
        console: ConsoleStore.PropType.isRequired,
        emailReg: EmailRegStore.PropType.isRequired,
        regOptions: RegOptionsStore.PropType.isRequired,
        snack: SnackStore.PropType.isRequired,
    };

    componentWillMount() {
        this.loadConfigurations(this.props);
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.emailReg !== this.props.emailReg) {
            this.loadConfigurations(nextProps);
        }
    }

    loadConfigurations = (props) => {
        if (!this.props.console.isSSOConfigured) {
            return;
        }
        props.emailReg.loadConfigurations()
            .catch((error) => this.props.snack.showError(`Failed to load saml-sso configurations ${error.message}`));
    };

    onSaveClick = () => {
        const { snack, emailReg, regOptions } = this.props;
        emailReg.save()
            .then((data) => {
                regOptions.setEmailReg(data);
                snack.showSuccess(<span><b>Browser Registration</b> has been saved.</span>);
            })
            .catch(() => snack.showError('Failed to save browser registration, please try again later'));
    };

    renderHeaderAction = () => {
        const { emailReg } = this.props;

        return <FuseButton
            style={{ minWidth: 100 }}
            color={'green'}
            primary
            disabled={!emailReg.hasChanged}
            loading={emailReg.saveStatus.isLoading}
            onClick={this.onSaveClick}
        >Save</FuseButton>;
    };

    render() {
        const { emailReg, regOptions } = this.props;

        return <FuseConsoleModal
            isOpen={emailReg.modal.isOpen}
            onClose={emailReg.close}
            title="Edit Browser Registration"
            className={block()}
            contentClassName={block('Content')}
            headerActions={this.renderHeaderAction()}
        >
            <Card title={'Registration Options'}>
                <FuseSwitch
                    header={'Registration Status'}
                    headerInfo="Allow the registration of new Browser/Email users. If disabled, any previously
                                registered browsers will remain active."
                    headerInfoPosition="bottom"
                    store={emailReg.browserRegistrationEnabled}
                    label={emailReg.browserRegistrationEnabled.value ? 'Enabled' : 'Disabled'}
                />

                {emailReg.browserRegistrationEnabled.value ? (
                    <Fragment>
                        {emailReg.configStatus.isLoading ? (
                            <UDSpinner type={'fuse'} className={block('Loader')} />
                        ) : (
                            <Fragment>
                                <div className={block('RegistrationTypeHeader')}>
                                    <FTLabel>Registration Type</FTLabel>
                                    <FuseInfoTooltip>
                                        Specify the mechanism to use for new Browser/Email
                                        registrations.
                                    </FuseInfoTooltip>
                                </div>

                                <FuseRadioButton
                                    disabled={!emailReg.samlSSOEnabled.isTrue}
                                    store={emailReg.registrationTypeStore}
                                    value={EmailRegStore.OPTION_SAML_SSO}
                                    label={<Fragment>
                                        <b>SAML/SSO</b> - users will be routed to the configured IdP for authentication.
                                    </Fragment>}
                                />

                                <FuseRadioButton
                                    store={emailReg.registrationTypeStore}
                                    value={EmailRegStore.OPTION_CODES}
                                    label={<Fragment>
                                        <b>Activation Codes</b>
                                        - users will be emailed a one-time activation code to register their browser.
                                    </Fragment>}
                                />

                                <FuseRadioButton
                                    store={emailReg.registrationTypeStore}
                                    value={EmailRegStore.OPTION_LINKS}
                                    label={<Fragment>
                                        <b>Activation Links</b>
                                        - users will be emailed a one-time activation link to register their browser.
                                    </Fragment>}
                                />

                                {!emailReg.samlSSOEnabled.isTrue && regOptions.useSsoLogin ? <FuseAlert
                                    type={'warning'}
                                    title={'Warning -'}
                                    className={block('SSODisabledWarning')}
                                    subtitle={'SAML/SSO Configuration is currently disabled.' +
                                    ' Users will see an error while trying to register.'}
                                /> : null}

                                {!emailReg.samlSSOEnabled.isTrue && !regOptions.useSsoLogin ? <FuseConsoleCardFooter
                                    className={block('WarningFooter')}
                                    text={'SAML/SSO must be enabled in order to select it as a registration type.'}
                                /> : null}
                            </Fragment>
                        )}
                    </Fragment>
                ) : null}
            </Card>

            <FuseConfirmationModal
                store={emailReg.exitConfirmationModal}
                onConfirm={emailReg.modal.close}
            />
        </FuseConsoleModal>;
    }
}

export default inject('snack', 'console', 'emailReg', 'regOptions')(observer(BrowserRegistrationModal));
